var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.3f0a44ae3a2b30274146fe60fae83dd2.svg#s';
                    var viewUrl = 'sprites.3f0a44ae3a2b30274146fe60fae83dd2.svg#view-s';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 13 13',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };